import React from 'react';
import { ButtonProps } from '@mui/material';
import ResponsiveButton, { ResponsiveButtonProps } from './ResponsiveButton';

/**
 * @deprecated Use ResponsiveButton instead. This component is kept for backward compatibility.
 * 
 * Componente Button adaptativo para mobile.
 * Em mobile, mostra apenas o ícone se mobileIconOnly=true.
 * Em desktop, mostra o botão completo com texto e ícone.
 */
interface MobileButtonProps extends Omit<ButtonProps, 'startIcon' | 'endIcon'> {
  icon: React.ReactNode;
  mobileIconOnly?: boolean;
  tooltipTitle?: string;
  preventDoubleClick?: boolean;
}

const MobileButton: React.FC<MobileButtonProps> = (props) => {
  // Mapear props antigas para ResponsiveButton
  // Construir objeto apenas com propriedades definidas para evitar problemas com exactOptionalPropertyTypes
  const responsiveProps: ResponsiveButtonProps = {
    ...props,
    icon: props.icon,
    ...(props.mobileIconOnly !== undefined && { mobileIconOnly: props.mobileIconOnly }),
    ...(props.tooltipTitle !== undefined && { tooltipTitle: props.tooltipTitle }),
    ...(props.preventDoubleClick !== undefined && { preventDoubleClick: props.preventDoubleClick }),
  };

  return <ResponsiveButton {...responsiveProps} />;
};

export default MobileButton;

